import React from 'react'
import { UserRole, AllUsers_users_users, useAuth } from '@modmd/data'
import { useHistory } from 'react-router-dom'
import Button from 'components/Button'
import { Text } from 'components/Typography'
import { ROUTES } from 'internal-portal/constants/routes'

export interface Props {
  vaccine?: boolean
  onUserSelect?: (user: Omit<AllUsers_users_users, '__typename'>) => void
  id: string
  user: string
}

export const AddStaffVerifier: React.VFC<Props> = ({ user, vaccine }) => {
  const { hasRoles } = useAuth()
  const isNurseOrSuperAdminOrResult = hasRoles([
    UserRole.NURSE,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.CLS,
    UserRole.RESULTS,
  ])
  const history = useHistory()

  const ButtonAllow = () => {
    if (isNurseOrSuperAdminOrResult) {
      return (
        <Button onClick={() => user && history.push(`/${ROUTES.USERS}/${user}`, { vaccine })}>
          Review
        </Button>
      )
    }
    return <Text>On review</Text>
  }

  return <ButtonAllow />
}
